import { Link } from "react-router-dom";
import { CheckCircle2, Target, Eye, Award, Globe2 } from "lucide-react";
import { COMPANY } from "../mock";

export default function About() {
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0a2540] to-[#1e40af] text-white py-16">
        <div className="container-x">
          <div className="text-xs uppercase tracking-[3px] opacity-80">About Us</div>
          <h1 className="brand-serif text-4xl md:text-5xl font-extrabold mt-2">About Fortunexis LLC</h1>
          <div className="text-sm mt-4 opacity-80"><Link to="/" className="hover:text-amber-300">Home</Link> / About Us</div>
        </div>
      </section>

      <section className="section">
        <div className="container-x grid md:grid-cols-2 gap-12 items-center">
          <div className="rounded-2xl overflow-hidden shadow-xl border-4 border-white">
            <img src="https://images.pexels.com/photos/16370914/pexels-photo-16370914.jpeg" alt="office" className="w-full h-[460px] object-cover" />
          </div>
          <div>
            <div className="section-eyebrow">Who We Are</div>
            <h2 className="section-title mt-2">Trusted Financial Advisory since 2019</h2>
            <p className="text-slate-600 mt-5 leading-relaxed">Fortunexis LLC is a specialised financial consultancy headquartered in Dubai. We provide comprehensive trade finance, project finance and corporate advisory services to businesses across the GCC, Asia, Europe and Africa.</p>
            <p className="text-slate-600 mt-4 leading-relaxed">With hands-on experience across global markets, our team brings deep domain expertise combined with a strong network of banking and institutional partners.</p>
            <ul className="mt-6 grid grid-cols-2 gap-3 text-sm text-slate-700">
              {["Global Bank Network", "Dedicated Consultants"].map((k) => (
                <li key={k} className="flex items-center gap-2"><CheckCircle2 size={16} className="text-[#1e40af]" /> {k}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="section bg-[#eff6ff]">
        <div className="container-x grid md:grid-cols-3 gap-6">
          {[
            { icon: Target, title: "Our Mission", text: "To empower businesses with reliable, structured financial solutions that enable sustainable growth." },
            { icon: Eye, title: "Our Vision", text: "To be the most trusted financial advisory partner across the GCC and emerging markets." },
            { icon: Award, title: "Our Values", text: "Integrity, professional excellence, transparency and long-term client relationships." },
          ].map((b) => (
            <div key={b.title} className="bg-white p-8 rounded-xl border border-slate-100 hover:shadow-lg transition-shadow">
              <div className="icon-badge mb-5"><b.icon size={28} /></div>
              <h3 className="text-[#0a2540] font-bold text-lg">{b.title}</h3>
              <p className="text-slate-600 mt-2 leading-relaxed">{b.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="container-x">
          <div className="text-center max-w-2xl mx-auto mb-10">
            <div className="section-eyebrow">Global Presence</div>
            <h2 className="section-title mt-2">Our Offices</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {COMPANY.offices.map((o) => (
              <div key={o.city} className="p-6 rounded-xl border border-slate-100 hover:border-[#1e40af] transition-colors">
                <Globe2 className="text-[#1e40af]" />
                <h4 className="text-[#0a2540] font-bold mt-3">{o.city}</h4>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{o.details}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
